module.exports = __webpack_public_path__ + "img/LogonoahEnero.aff7cf51.png";